export default "__VITE_ASSET__SMAUhU2f__"